export default __webpack_public_path__ + "static/media/brick-bg.47469b8e.png";